var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234,
    height: 55,
    viewBox: "0 0 234 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233 9C233 4.58172 229.418 1 225 1H9C4.58173 1 1 4.58172 1 9V46C1 50.4183 4.58172 54 9 54H225C229.418 54 233 50.4183 233 46L233 9Z",
    fill: "url(#paint0_linear_18_20)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5H225C229.694 0.5 233.5 4.30558 233.5 9L233.5 46C233.5 50.6944 229.694 54.5 225 54.5H9C4.30557 54.5 0.5 50.6944 0.5 46V9C0.5 4.30558 4.30559 0.5 9 0.5Z",
    stroke: "url(#paint1_linear_18_20)",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5H225C229.694 0.5 233.5 4.30558 233.5 9L233.5 46C233.5 50.6944 229.694 54.5 225 54.5H9C4.30557 54.5 0.5 50.6944 0.5 46V9C0.5 4.30558 4.30559 0.5 9 0.5Z",
    stroke: "url(#paint2_linear_18_20)",
    strokeOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.445 20.6664L207.748 25.9697C208.041 26.2625 208.041 26.7375 207.748 27.0303L202.445 32.3336C202.152 32.6264 201.677 32.6264 201.384 32.3336C201.091 32.0409 201.091 31.5658 201.384 31.273L205.407 27.2499L193.783 27.2499C193.368 27.2499 193.033 26.9143 193.033 26.5C193.033 26.0857 193.368 25.7501 193.783 25.7501L205.407 25.7501L201.384 21.727C201.091 21.4342 201.091 20.9591 201.384 20.6664C201.677 20.3736 202.152 20.3736 202.445 20.6664Z",
    fill: "#91E2EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_20",
    x: 181.033,
    y: 8.44678,
    width: 38.9349,
    height: 36.1064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643137 0 0 0 0 0.964706 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_20",
    x1: 209.033,
    y1: 82.5385,
    x2: 32.5152,
    y2: -11.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_20",
    x1: 117,
    y1: 1,
    x2: 117,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_20",
    x1: 117,
    y1: 7,
    x2: 117,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3F5FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3F5FE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBg);
export default __webpack_public_path__ + "static/media/btn-bg.302cc45e.svg";
export { ForwardRef as ReactComponent };